var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIsovalentinline = function SvgIsovalentinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 40,
    fill: "none",
    viewBox: "0 0 182 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#isovalent_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0078FB",
    fillRule: "evenodd",
    d: "M32.447 3.001H10.816L0 20.989l10.816 17.988h21.631L43.263 20.99 32.447 3.001Zm-5.562 9.25H16.378l-5.254 8.738 5.254 8.738h10.507l5.254-8.738-5.254-8.738",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#737373",
    d: "M18.479 15.74h6.27l3.135 5.214-3.135 5.215h-6.27l-3.135-5.215 3.135-5.214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464646",
    d: "M24.755 26.173 21.66 20.96l-3.176 5.214h6.27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C7C7",
    d: "M24.755 15.74h-6.27l3.175 5.214 3.095-5.214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "m24.75 15.74-3.096 5.214h6.247l-3.152-5.214m-3.096 5.214L18.48 15.74l-3.135 5.214h6.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0058FB",
    d: "m32.44 38.978 10.817-17.989H32.133l-5.254 8.738 5.562 9.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0078FB",
    d: "m32.44 38.978 5.563-9.25H26.879l5.562 9.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CBAFB",
    d: "M38.025 12.254H26.88l5.254 8.738 5.892-8.738"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9DDAFB",
    d: "m38.03 12.263-5.893 8.725H43.26l-5.232-8.725"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0069E4",
    d: "m21.633 38.978 5.254-9.25 5.561 9.25H21.633"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0101D7",
    d: "M0 20.99h11.124l-5.87 8.737h11.124l5.414 9.25H10.816l-5.562-9.25L0 20.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0035FB",
    fillRule: "evenodd",
    d: "m11.124 20.992-5.85-8.738L0 20.992h11.124l5.254 8.738H5.274l5.85-8.738",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0027FB",
    d: "m26.883 12.251-5.094-9.25-5.414 9.25h10.508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A0FB",
    d: "m32.44 3.001-5.561 9.25h11.146l-5.584-9.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0101D7",
    d: "M116.486 21.983h1.13l.565.935-.565.934h-1.13l-.564-.934.564-.935"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A0B0F",
    d: "M59.2 26.924V15.487h1.517v11.437H59.2m15.464-9.037c-.28-.3-.714-.575-1.299-.822-.584-.247-1.237-.37-1.957-.37-.922 0-1.602.166-2.04.5-.44.332-.659.789-.659 1.369 0 .408.113.73.338.966.225.236.568.43 1.029.58.472.15 1.068.306 1.788.467.832.172 1.552.381 2.16.628.607.247 1.073.58 1.4 1 .325.407.488.955.488 1.642 0 .73-.19 1.332-.573 1.804-.382.473-.905.822-1.569 1.047-.652.226-1.389.339-2.21.339-1.867 0-3.492-.537-4.875-1.611l.725-1.224c.248.236.58.472.996.708.427.237.91.435 1.45.596.552.15 1.13.226 1.738.226.855 0 1.518-.145 1.99-.435.473-.3.71-.736.71-1.305 0-.43-.136-.773-.406-1.03-.258-.259-.647-.473-1.164-.645a21.517 21.517 0 0 0-1.89-.516c-.809-.193-1.49-.402-2.04-.628-.551-.236-.968-.542-1.248-.918-.27-.376-.406-.864-.406-1.466 0-.73.186-1.348.557-1.852.371-.505.883-.886 1.535-1.144.653-.258 1.39-.387 2.21-.387.799 0 1.524.118 2.176.355a6.165 6.165 0 0 1 1.755.95l-.709 1.176m12.152 9.118c-.843 0-1.608-.162-2.294-.484a5.723 5.723 0 0 1-1.788-1.305 6.23 6.23 0 0 1-1.147-1.868 5.894 5.894 0 0 1-.405-2.143c0-.762.14-1.487.422-2.174a6.128 6.128 0 0 1 1.197-1.853 5.703 5.703 0 0 1 1.805-1.289 5.211 5.211 0 0 1 2.244-.483c.844 0 1.608.167 2.294.5a5.62 5.62 0 0 1 1.771 1.337 6.23 6.23 0 0 1 1.147 1.868c.27.688.406 1.391.406 2.11 0 .763-.141 1.493-.422 2.191a5.969 5.969 0 0 1-1.198 1.853 5.627 5.627 0 0 1-1.788 1.272 5.361 5.361 0 0 1-2.244.468m-4.099-5.8c0 .58.096 1.144.287 1.692a4.75 4.75 0 0 0 .843 1.434c.36.418.793.751 1.3.998.505.247 1.067.37 1.686.37.641 0 1.215-.128 1.72-.386a3.925 3.925 0 0 0 1.283-1.03c.36-.43.63-.914.81-1.45.19-.538.287-1.08.287-1.628 0-.58-.102-1.138-.304-1.675a4.331 4.331 0 0 0-.844-1.434 3.734 3.734 0 0 0-1.299-.998 3.65 3.65 0 0 0-1.653-.37c-.64 0-1.214.128-1.72.386-.507.247-.94.585-1.3 1.015-.348.43-.618.912-.81 1.45a4.729 4.729 0 0 0-.286 1.626m15.784-5.718 3.965 9.617 3.947-9.617h1.603l-4.859 11.437h-1.383l-4.875-11.437H98.5m17.849 0h1.282l4.892 11.437h-1.726l-1.31-3.35-2.497-6.412-3.93 9.762h-1.62l4.909-11.437m11.821 11.437V15.487h1.519v10.148h6.68v1.29h-8.199m22.031-1.289v1.29h-8.131V15.486h7.979v1.289h-6.46v3.704h5.617v1.209h-5.617v3.946h6.612m7.65-7.474v8.763h-1.518V15.487h1.282l7.321 8.94v-8.924h1.518v11.421h-1.383l-7.22-8.763M182 16.775h-4.132v10.15h-1.519v-10.15h-4.133v-1.288H182v1.289"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "isovalent_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .001h182v40H0z"
  })))));
};
export default SvgIsovalentinline;